// The pill is fed the raw backend TransactionStatus (a wide enum). `normalizeStatus` collapses every raw value
// into a single strongly-typed set of visual variants — one distinct icon + color each — so the pill's maps are
// exhaustive and need no runtime fallback. Synonyms collapse (successful/complete/settled → success); the
// semantic values GetColorStatus emits (positive/negative/…) map in too; anything unmapped is neutral `pending`.
export type TransactionStatusVariant =
  | 'pending'
  | 'success'
  | 'failed'
  | 'reversed'
  | 'blocked'
  | 'partiallyPaid'
  | 'upcoming';

const STATUS_VARIANT_BY_RAW: Record<string, TransactionStatusVariant> = {
  successful: 'success',
  complete: 'success',
  completed: 'success',
  settled: 'success',
  active: 'success',
  positive: 'success',
  approved: 'success',
  failed: 'failed',
  negative: 'failed',
  cancelled: 'failed',
  rejected: 'failed',
  reversed: 'reversed',
  blocked: 'blocked',
  'partially paid': 'partiallyPaid',
  upcoming: 'upcoming',
};

export function normalizeStatus(status: string): TransactionStatusVariant {
  return STATUS_VARIANT_BY_RAW[status.toLowerCase().trim()] ?? 'pending';
}
